<template>

  <div>
    <el-tree
        class="filter-tree"
        :data="documents"
        :props="defaultProps"
       >

       <span class="custom-tree-node" slot-scope="{ node, data }">
         <folder-list-item v-if="data.documents" :folder="data" ></folder-list-item>
         <document-item v-else :document="data" :user="user"></document-item>

      </span>

    </el-tree>
  </div>
</template>

<script>
import FolderListItem from "@/components/documents/FolderListItem"
import DocumentItem from "@/components/documents/DocumentItem"

export default {
  name: "FolderList",
  data() {
    return {

      loading: false,

      defaultProps: {
        children: 'documents',
        label: 'label'
      },

    }
  },
  components: {
    FolderListItem,
    DocumentItem
  },
  props: {
    documents: {},
    user: {}
  },
  watch: {},
  computed: {},
  methods: {}
}
</script>

<style scoped lang="scss">

.filter-tree {

  background: transparent;

  /deep/ {
    .el-tree-node__content {
      cursor: default;
      height: auto;
    }

    .el-tree-node__content > .el-tree-node__expand-icon {
      display: none;
    }

    .custom-tree-node {
      width: 100%;
    }

    .is-expanded > .el-tree-node__content > .custom-tree-node {


      & > .folder-list {
        background: #E5E6EA;

        .right-side {

          &__icon {
            transform: rotate(90deg);
          }
        }
      }
    }

    .el-tree-node__content {
      padding-left: 0 !important;
    }
  }
}
</style>
